import {
  Text,
  TextAlignment,
  TextAppearance,
} from '@vw-marketing/us-components';
import React from 'react';
import { EmissionsModel } from '../../../typings/general';
import {
  Table,
  TableInformationContainer,
  Tbody,
  Td,
  TdShort,
  Tr,
} from './styled';

interface TableInformationProps {
  emissionsData: EmissionsModel;
}

export const TableInformation: React.FC<TableInformationProps> = ({
  emissionsData,
}) => {
  const tableMatchLabel = {
    TML1: 'TML1',
    TML2: 'TML2',
    TML3: 'TML3',
    TML4: 'TML4',
  };

  const getCustomText = (text: string, textCenter: boolean, isBold = false) => (
    <Text
      appearance={TextAppearance.copy200}
      bold={isBold}
      textAlign={textCenter ? TextAlignment.center : TextAlignment.left}
    >
      {text}
    </Text>
  );

  const getTableMatchLabel = (key: string) => {
    switch (key) {
      case tableMatchLabel.TML1:
        return emissionsData.tdiEligible ? 'Yes' : 'No';

      case tableMatchLabel.TML2:
        return emissionsData.remedyAvailable ? 'Yes' : 'No';

      case tableMatchLabel.TML3:
        return emissionsData.remedyAvailable
          ? emissionsData.repairComplete
            ? 'Yes'
            : emissionsData.extendedWarrantyApplied
              ? 'Partial'
              : 'No'
          : 'NOT APPLICABLE';

      case tableMatchLabel.TML4:
        return emissionsData.remedyAvailable
          ? emissionsData.extendedWarrantyApplied
            ? 'Yes'
            : emissionsData.repairComplete
              ? 'Pending'
              : '	No - Requires Completed Modification'
          : 'NOT APPLICABLE';

      default:
        return '';
    }
  };

  return (
    <TableInformationContainer>
      <Table>
        <Tbody>
          <Tr>
            <Td>
              {getCustomText('Vehicle (VIN) Included in Settlement:', false)}
            </Td>
            <TdShort>
              {getCustomText(
                getTableMatchLabel(tableMatchLabel.TML1),
                true,
                true,
              )}
            </TdShort>
          </Tr>
          <Tr>
            <Td>
              {getCustomText('Modification Approved by EPA and CARB:', false)}
            </Td>
            <TdShort>
              {getCustomText(
                getTableMatchLabel(tableMatchLabel.TML2),
                true,
                true,
              )}
            </TdShort>
          </Tr>
          <Tr>
            <Td>
              {getCustomText(
                'Modification Completed for this Vehicle (VIN):',
                false,
              )}
            </Td>
            <TdShort>
              {getCustomText(
                getTableMatchLabel(tableMatchLabel.TML3),
                true,
                true,
              )}
            </TdShort>
          </Tr>
          <Tr>
            <Td>
              {getCustomText('Vehicle has Extended Emissions Warranty:', false)}
            </Td>
            <TdShort>
              {getCustomText(
                getTableMatchLabel(tableMatchLabel.TML4),
                true,
                true,
              )}
            </TdShort>
          </Tr>
        </Tbody>
      </Table>
    </TableInformationContainer>
  );
};
